<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" :label="$t('USERNAME')" label-for="username-input">
          <b-form-input
            id="username-input"
            v-model="user.Username"
            type="text"
            required
            :placeholder="$t('USERNAME')"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" :label="$t('FIRSTNAME')" label-for="firstname-input">
          <b-form-input
            id="firstname-input"
            v-model="user.Firstname"
            type="text"
            required
            :placeholder="$t('FIRSTNAME')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" :label="$t('LASTNAME')" label-for="lastname-input">
          <b-form-input
            id="lastname-input"
            v-model="user.Lastname"
            type="text"
            required
            :placeholder="$t('LASTNAME')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" :label="$t('RESET_PW')" label-for="resetPassword-input">
          <b-form-input
              id="resetPassword-input"
              v-model="password"
              type="text"
              :placeholder="$t('RESET_PW')"
          ></b-form-input>
        </b-form-group>
        
        <b-form-group>
          <div class="d-flex align-items-center">
            <b-button type="submit" variant="primary">{{$t("APPLY")}}</b-button>
            <b-button type="button" id="resetPassword" v-on:click="onUpdateUserPassword">{{$t("RESET_PASSWORD")}}</b-button>
          </div>
        </b-form-group>


      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPut } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["Id", "token"],
  data: function() {
    return {
      loading: true,
      user: {
        Username: "",
        Firstname: "",
        Lastname: ""
      },
      password:""
    };
  },
  mounted: function() {
    var esp = this;

    setTimeout(function() {
      ajaxGet(
        apiUrl()+ "/users/" +
          esp.Id,
        esp.onGetUser,
        esp.onError,
        esp.token
      );
    }, 100);
  },
  methods: {
    onError(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    },
    onGetUser(data) {
      this.loading = false;
      this.user = data;
    },
    onSubmit(event) {
      event.preventDefault();

      this.loading = true;
      ajaxPut(
        apiUrl() + "/users/" +
          this.Id,
        this.user,
        this.onUpdateUser,
        this.onError,
        this.token
      );
    },
    onUpdateUser() {
      this.$bvToast.toast("User updated!", {
        autoHideDelay: 5000,
        appendToast: true
      });
      this.loading = false;
    },
    onUpdateUserPassword(event){
      let resetInput = document.getElementById("resetPassword-input");
      if(resetInput.value === ""){
        alert("To reset password, please enter a value.")
        event.preventDefault();
      }
      this.loading = true;
      ajaxPut(apiUrl() +"/users/reset" ,
          {
            ID:this.Id,
            Password: this.password,
          },
          this.onUpdateUser,
          this.onError,
          this.token
      );
      
    }
    
  }
};
</script>